import {
  IShowCategoryInParamItemWithContext,
  IShowCategoryInParamItemWithField,
  IShowCategoryInParamItemWithInParam,
  IShowCategoryInParamItemWithState,
  IShowCategoryInParamItemWithValue,
  ShowCategoryInParamItem,
} from '@infotech-soe/metaschema';

export const isShowCategoryArgWithState = (
  val: ShowCategoryInParamItem
): val is IShowCategoryInParamItemWithState =>
  (val as IShowCategoryInParamItemWithState).fromState !== undefined;

export const isShowCategoryArgWithField = (
  val: ShowCategoryInParamItem
): val is IShowCategoryInParamItemWithField =>
  (val as IShowCategoryInParamItemWithField).field !== undefined;

export const isShowCategoryArgWithInParam = (
  val: ShowCategoryInParamItem
): val is IShowCategoryInParamItemWithInParam =>
  (val as IShowCategoryInParamItemWithInParam).context === 'InParams' &&
  (val as IShowCategoryInParamItemWithInParam).inParam !== undefined;

export const isShowCategoryArgWithContext = (
  val: ShowCategoryInParamItem
): val is IShowCategoryInParamItemWithContext =>
  (val as IShowCategoryInParamItemWithContext).context !== undefined &&
  (val as IShowCategoryInParamItemWithInParam).context !== 'InParams';

export const isShowCategoryArgWithValue = (
  val: ShowCategoryInParamItem
): val is IShowCategoryInParamItemWithValue =>
  (val as IShowCategoryInParamItemWithValue).value !== undefined;
